import { CountryCode } from '@/utils/address'

import { currencies } from './currencies'

export const getCurrency = (countryCode: CountryCode) => {
    const code = currencies[countryCode]

    const symbol = (0)
        .toLocaleString(countryCode, {
            style: 'currency',
            currency: code,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })
        .replace(/\d/g, '')
        .trim()

    return { code, symbol }
}
